import Request from 'superagent';
import urlResolver from 'admin/utils/URLResolver';
import { get, post } from 'edrolo/domains/net';

export async function loadAttachments(
  classId,
  attachmentType,
  objectId,
  isDemo
) {
  // attachmentType is one of the ATTACHMENT_TYPE enum. Anything else will 404.
  const url = isDemo
    ? urlResolver.reverse('api:demo-attachments', {
        attachmentType,
        objectId,
      })
    : urlResolver.reverse('api:class-attachments', {
        classId,
        attachmentType,
        objectId,
      });

  return get(url);
}

export async function doesWatermarkedAttachmentExist(url) {
  // makes a HEAD request to a s3 url. Returns true if the file is there
  // Note that non-public s3 buckets return 403 responses for absent files,
  // because the file is not there to provide "public readable" permission.
  try {
    await Request.head(url);
    return true;
  } catch (err) {
    if ([403, 404].includes(err.status)) {
      return false;
    }
    throw new Error('failed to head watermarked attachment', err);
  }
}

export async function triggerWatermarkCourseAttachments(classId) {
  return post(
    urlResolver.reverse('api:watermark-course-attachments', {
      classId,
    }),
    {}
  );
}
